export default "__VITE_ASSET__QEkFP0ML__"